import PropTypes from "prop-types";
import { Orders } from "vino/components";

const Block = ({ attributes }) => {
	return <Orders attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
